import * as React from "react";
import { FormattedMessage } from "react-intl";
// components
import InterestItem from "../interestItem";
import StarHandler from "common/components/handlers/starHandler";
import MenuHandler from "common/components/handlers/menuHandler";
import BoostHandler from "common/components/handlers/boostHandler";
import NoData from "../noData";
// styles

const styles = require("./allInterestsList.scss");

interface IAllInterestsListProps {
  interests: ReadonlyArray<Vingle.UserProfile.IProfileInterestState>;
  listTitle: string;
  isMine: boolean;
  canEdit: boolean;
  username: string;
  handleBoostClick?: (
    interest: Vingle.UserProfile.IProfileInterestState,
  ) => void;
  handleMainInterestClick?: (
    interest: Vingle.UserProfile.IProfileInterestState,
  ) => void;
  handleMenuClick?: (
    interest: Vingle.UserProfile.IProfileInterestState,
    anchor: any,
  ) => void;
}

const DATA_INTEREST = "data-interest";
class AllInterestsList extends React.PureComponent<IAllInterestsListProps> {
  public render() {
    const { interests, listTitle, isMine, canEdit, username } = this.props;
    const items: React.ReactNode[] = [];
    interests.forEach(
      (interest: Vingle.UserProfile.IProfileInterestState, index: number) => {
        if (interest.data) {
          let handlers: React.ReactNode;

          if (isMine && canEdit) {
            handlers = (
              <div className={styles.handlerWrapper}>
                <StarHandler
                  data-interest={interest.data.interest.name}
                  onClick={this.handleStarClick}
                  checked={false}
                  disable={interest.data.private}
                />
                <MenuHandler
                  data-interest={interest.data.interest.name}
                  onClick={this.handleMenuClick}
                />
              </div>
            );
          } else {
            handlers = (
              <div className={styles.handlerWrapper}>
                <BoostHandler
                  data-interest={interest.data.interest.name}
                  onClick={this.handleBoostClick}
                  isBoosted={interest.data.relation.boost}
                />
              </div>
            );
          }

          items.push(
            <InterestItem
              key={`all_interest_item_${interest.data.interest.name}`}
              username={username}
              interestData={interest.data}
              isDeleting={interest.meta.isDeleting}
              isLast={interests.length === index + 1}
            >
              {handlers}
            </InterestItem>,
          );
        }
      },
    );

    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>{listTitle}</div>
        <ul>{items}</ul>
        {items.length === 0 ? (
          <NoData
            message={<FormattedMessage id="interests.no_interests_data" />}
          />
        ) : (
          undefined
        )}
      </div>
    );
  }

  private readonly handleStarClick: React.MouseEventHandler<
    HTMLDivElement
  > = e => {
    const { handleMainInterestClick } = this.props;
    const interest = this.findInterest(
      e.currentTarget.getAttribute(DATA_INTEREST),
    );
    if (handleMainInterestClick && interest) {
      handleMainInterestClick(interest);
    }
  };

  private readonly handleMenuClick: React.MouseEventHandler<
    HTMLDivElement
  > = e => {
    const { handleMenuClick } = this.props;
    const interest = this.findInterest(
      e.currentTarget.getAttribute(DATA_INTEREST),
    );
    if (handleMenuClick && interest) {
      handleMenuClick(interest, e.currentTarget);
    }
  };

  private readonly handleBoostClick: React.MouseEventHandler<
    HTMLDivElement
  > = e => {
    const { handleBoostClick } = this.props;
    const interest = this.findInterest(
      e.currentTarget.getAttribute(DATA_INTEREST),
    );
    if (handleBoostClick && interest) {
      handleBoostClick(interest);
    }
  };

  private readonly findInterest = (
    interestName: string | null,
  ): Vingle.UserProfile.IProfileInterestState | undefined => {
    const { interests } = this.props;
    return interests.filter(interest => {
      return interest.data && interest.data.interest.name === interestName;
    })[0];
  };
}

export default AllInterestsList;
